/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PassportShippingTruck from '../../../assets/svg/PassportShippingTruck';
import BuildingSolid from '../../../assets/svg/BuildingSolid';
import HomeSolid from '../../../assets/svg/HomeSolid';

const DesktopDeliveryHours = () => (
    <div className="deliveryHouseContainer">
        <PassportShippingTruck className="truckIcon" />
        <div className="deliveryText">
            <span>Delivery</span>
            <span>Hours</span>
        </div>
        <span className="line" />
        <div className="hosueContainer">
            <div><HomeSolid className="houseIcon" /></div>
            <div className="leftIconMargin">
                <span>Residential:</span>
                <span><b>9AM to 8PM</b></span>
            </div>
        </div>
        <div className="bulidingContainer">
            <div> <BuildingSolid className="bulidingIcon" /> </div>
            <div className="leftIconMargin">
                <span>Businesses:</span>
                <span><b>9AM to 6PM</b></span>
            </div>
        </div>
    </div>
);

export default DesktopDeliveryHours;
